const API_BASE_URL = "https://api.ringarenshotell.se";
// const API_BASE_URL = "http://localhost:3007";

export default API_BASE_URL;